import { defKSUID32 } from '@thi.ng/ksuid';

export const generateKSUID = () => {
  try {
    const ksuidGenerator = defKSUID32();
    const ksuid = ksuidGenerator.next();
    return `EAR-${ksuid}`;
  } catch (error) {
    console.error('Failed to generate KSUID:', error);
  }
};
